import { Box, Typography } from "@mui/material";
import { TOKENS } from "../constants/figmaTokens";

export function addressLines(bodyAddress, pin, gst) {
  return [
    bodyAddress.display_name,
    bodyAddress.line_one,
    bodyAddress.line_two,
    bodyAddress.line_three,
    bodyAddress.city,
    bodyAddress.state,
  ]
    .filter(Boolean)
    .concat([`Pin: ${pin || "NA"}`, `GSTIN: ${gst || "NA"}`]);
}

export default function AddressRows({ bodyAddress, pin, gst }) {
  if (!bodyAddress) return "-";
  return (
    <Box>
      {addressLines(bodyAddress, pin, gst).map((line, idx) => (
        <Typography key={idx} sx={{ fontSize: 13, lineHeight: "18px", color: TOKENS.onSurfaceDefault }}>
          {line}
        </Typography>
      ))}
    </Box>
  );
}
